import axios from "axios";

export function getAvaiblePreRegistration() {
  return axios.get(process.env.VUE_APP_API_URL + "PreRegistration/GetAvabilePreRegistrations");
}

export function buyPackage(data) {
  return axios.post(process.env.VUE_APP_API_URL + "PreRegistration/buy", data);
}
